export default __webpack_public_path__ + "static/media/Cinnamon-Rolls.3303fd6b.jpg";